<div class="confirm-container">
  @if (title) {
    <h1>{{title}}</h1>
  }
  <div [innerHtml]="message"></div>
  <div class="actions">
    <button mat-raised-button color="primary" (click)="confirm()" class="confirm">{{this.confirmText || 'Yes'}}</button>
    <button mat-button (click)="cancel()" class="cancel">{{this.cancelText || 'No'}}</button>
  </div>
</div>